var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 118,
    viewBox: "0 0 101 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01435 110.988L4.64222 111.81L4.90082 109.314C5.70212 101.588 6.50317 93.8613 7.30407 86.1348L0.964844 117.999C0.964844 117.999 14.0855 107.548 34.6542 109.793C25.624 107.526 16.003 107.872 7.01435 110.988Z",
    fill: "#415BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5348 112.695C34.2879 106.1 19.7648 104.88 6.49219 109.48C7.57779 99.0098 8.6634 88.5393 9.7488 78.0684C18.1013 75.1798 26.8796 73.9062 35.6225 74.2646H35.621C37.8791 77.8978 39.4683 82.1081 40.6274 86.9318C41.7869 91.7566 42.729 96.6251 43.7699 101.475C44.5835 105.265 45.4651 109.002 46.5344 112.695L46.5348 112.695ZM65.8358 74.2429C74.3816 73.965 82.9509 75.2454 91.1136 78.0684C92.1992 88.5394 93.2848 99.0098 94.3704 109.48C80.6269 104.716 65.5424 106.194 53.0328 113.417C53.4203 110.974 53.8207 108.533 54.2956 106.091C55.5276 99.7582 57.1432 93.5514 59.1845 87.4293C60.738 82.7714 62.9399 78.2366 65.8358 74.2429Z",
    fill: "#304876"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.845 110.989L96.2173 111.811L95.9583 109.314C95.1572 101.588 94.3563 93.8618 93.5554 86.1353L99.8945 118C99.8945 118 86.7736 107.549 66.2051 109.793C75.2356 107.526 84.8565 107.873 93.845 110.989Z",
    fill: "#415BA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4421 117.995C46.2574 106.838 44.9303 96.4825 42.2403 85.2868C39.8988 75.5448 35.3732 65.28 21.6816 59.2918C21.6816 59.2918 40.8556 57.1929 50.4421 81.0048C50.4421 81.0048 56.4336 65.2822 70.8138 65.2822C70.8138 65.2822 62.4258 71.2721 57.632 85.6483C52.8387 100.025 51.6403 110.807 50.4421 117.995Z",
    fill: "#304876"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4382 28.8726C53.7222 30.5743 55.9663 34.0031 55.9663 37.9563C55.9663 41.5368 54.1253 44.6871 51.3383 46.5136L50.4382 35.8884L49.5383 46.5136C46.7511 44.6872 44.9102 41.5368 44.9102 37.9563C44.9102 34.0031 47.1544 30.5743 50.4382 28.8726Z",
    fill: "#304876"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7313 37.9803C33.257 36.8621 37.2689 37.7004 40.065 40.4957C42.5977 43.0276 43.5242 46.5565 42.8454 49.8181L34.6937 42.9411L41.5725 51.0906C38.3099 51.7693 34.7799 50.8431 32.2476 48.3113C29.4513 45.516 28.613 41.5049 29.7313 37.9803Z",
    fill: "#304876"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1445 52.6883C23.3742 50.2474 26.8546 49.1037 30.2687 50.0183C33.361 50.8468 35.6557 53.1646 36.5885 55.9927L27.2037 54.3114L36.172 57.5466C33.9497 59.5296 30.8033 60.39 27.7108 59.5614C24.2965 58.647 21.8546 55.9166 21.1445 52.6883Z",
    fill: "#304876"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84217 58.7329C7.71123 61.6207 9.15612 64.4797 11.8334 66.025C14.2578 67.4245 17.1109 67.4098 19.4371 66.2377L12.5935 61.4751L20.1408 65.0191C19.9932 62.4188 18.5796 59.9415 16.1548 58.542C13.4777 56.9967 10.2784 57.1752 7.84217 58.7329Z",
    fill: "#304876"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2107 38.3039C16.3364 41.0593 16.9919 44.1948 19.1777 46.3803C21.1576 48.3595 23.917 49.0836 26.4676 48.5531L21.0899 42.1822L27.4626 47.5582C27.9934 45.0084 27.2691 42.2496 25.2892 40.2705C23.1034 38.085 19.967 37.4297 17.2107 38.3039Z",
    fill: "#304876"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6785 23.7471C35.5433 25.6964 34.5427 28.7395 35.3428 31.7245C36.0673 34.4283 38.0949 36.4347 40.569 37.2503L39.0982 29.0447L41.9284 36.8862C43.6636 34.943 44.4157 32.1919 43.6912 29.4882C42.8911 26.5029 40.5027 24.3677 37.6785 23.7471Z",
    fill: "#304876"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77794 41.3696C2.65114 44.921 3.49566 48.9623 6.31315 51.7786C8.8648 54.3297 12.4214 55.2629 15.7086 54.5791L8.77792 46.368L16.9913 53.2971C17.6752 50.0106 16.7417 46.455 14.1901 43.9039C11.3726 41.0874 7.33019 40.2431 3.77794 41.3696Z",
    fill: "#304876"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5611 22.8749C16.4343 26.4264 17.2791 30.4676 20.0963 33.2842C22.648 35.835 26.2045 36.7685 29.4918 36.0848L22.5609 27.8733L30.7744 34.8024C31.4583 31.516 30.5249 27.9603 27.9732 25.4095C25.1558 22.593 21.1133 21.7484 17.5611 22.8749Z",
    fill: "#304876"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94339 29.8564C6.23701 32.0832 6.76656 34.6173 8.5332 36.3833C10.1329 37.9827 12.3632 38.568 14.4242 38.1393L10.0785 32.9905L15.2286 37.3351C15.6574 35.2747 15.0721 33.0451 13.472 31.4456C11.7056 29.6795 9.17082 29.1503 6.94339 29.8564Z",
    fill: "#304876"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2572 18.4795C30.0465 19.5848 29.4793 21.3102 29.933 23.0029C30.3436 24.5358 31.4934 25.6734 32.896 26.1358L32.0624 21.4835L33.6671 25.9294C34.6506 24.8277 35.0773 23.2678 34.6664 21.7349C34.2126 20.0422 32.8583 18.8316 31.2572 18.4795Z",
    fill: "#304876"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.224 19.5991C44.0134 20.7041 43.446 22.4296 43.8998 24.1222C44.3105 25.6552 45.4603 26.7927 46.863 27.2552L46.0292 22.6028L47.6338 27.0486C48.6175 25.947 49.0443 24.3872 48.6334 22.8542C48.1796 21.1615 46.8251 19.9509 45.224 19.5991Z",
    fill: "#304876"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7736 10.543C40.8482 11.6181 42.2659 13.7842 42.2659 16.2818C42.2659 18.5438 41.1031 20.534 39.3422 21.6881L38.7736 14.9753L38.2049 21.6881C36.4441 20.534 35.2812 18.5438 35.2812 16.2818C35.2813 13.7842 36.699 11.6181 38.7736 10.543Z",
    fill: "#304876"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00465137 59.1C1.38569 59.9831 3.19969 60.0844 4.71764 59.2083C6.09231 58.4146 6.89401 57.0099 6.9776 55.5357L2.69843 57.545L6.57885 54.8448C5.25979 54.18 3.64221 54.1719 2.26754 54.9653C0.749487 55.8416 -0.0696754 57.4626 0.00465137 59.1Z",
    fill: "#304876"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1398 37.9803C67.6143 36.8621 63.6021 37.7004 60.8061 40.4957C58.2736 43.0276 57.3469 46.5565 58.0259 49.8181L66.1776 42.9411L59.2988 51.0906C62.5614 51.7693 66.0912 50.8431 68.6237 48.3113C71.42 45.516 72.2583 41.5049 71.1398 37.9803Z",
    fill: "#304876"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9959 58.7334C93.127 61.6212 91.6822 64.4802 89.0049 66.0255C86.5803 67.4249 83.7274 67.4103 81.401 66.2382L88.2448 61.4756L80.6973 65.0196C80.8449 62.4193 82.2586 59.9419 84.6835 58.5425C87.3606 56.9972 90.56 57.1757 92.9959 58.7334Z",
    fill: "#304876"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6642 38.3039C84.5388 41.0593 83.8832 44.1948 81.6975 46.3803C79.7175 48.3595 76.9582 49.0836 74.4075 48.5531L79.7851 42.1822L73.4125 47.5582C72.8817 45.0084 73.606 42.2496 75.586 40.2705C77.7718 38.085 80.9081 37.4297 83.6642 38.3039Z",
    fill: "#304876"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.174 23.7471C65.3092 25.6964 66.3097 28.7395 65.5097 31.7245C64.7852 34.4283 62.7573 36.4347 60.2832 37.2503L61.754 29.0447L58.9238 36.8862C57.189 34.943 56.4365 32.1919 57.161 29.4882C57.9613 26.5029 60.3497 24.3677 63.174 23.7471Z",
    fill: "#304876"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0612 41.3696C98.188 44.921 97.3432 48.9623 94.5259 51.7786C91.9741 54.3297 88.4178 55.2629 85.1305 54.5791L92.0612 46.368L83.8476 53.2971C83.1639 50.0106 84.0974 46.455 86.649 43.9039C89.4665 41.0874 93.5087 40.2431 97.0612 41.3696Z",
    fill: "#304876"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2781 22.8749C84.4049 26.4264 83.5601 30.4676 80.7427 33.2842C78.1912 35.835 74.6347 36.7685 71.3474 36.0848L78.2783 27.8733L70.0645 34.8024C69.3806 31.516 70.3141 27.9603 72.8659 25.4095C75.6832 22.593 79.7256 21.7484 83.2781 22.8749Z",
    fill: "#304876"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.923 29.8564C94.6294 32.0832 94.0999 34.6173 92.3334 36.3833C90.7335 37.9827 88.5032 38.568 86.4422 38.1393L90.7881 32.9905L85.638 37.3351C85.209 35.2747 85.7945 33.0451 87.3944 31.4456C89.161 29.6795 91.6956 29.1503 93.923 29.8564Z",
    fill: "#304876"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5433 18.4795C70.7541 19.5848 71.3213 21.3102 70.8677 23.0029C70.457 24.5358 69.3072 25.6734 67.9043 26.1358L68.7381 21.4835L67.1335 25.9294C66.1498 24.8277 65.7232 23.2678 66.1342 21.7349C66.5878 20.0422 67.9422 18.8316 69.5433 18.4795Z",
    fill: "#304876"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6449 19.5991C56.8556 20.7041 57.4228 22.4296 56.9693 24.1222C56.5585 25.6552 55.4087 26.7927 54.0061 27.2552L54.8399 22.6028L53.2352 27.0486C52.2515 25.947 51.8247 24.3872 52.2357 22.8542C52.6894 21.1615 54.0437 19.9509 55.6449 19.5991Z",
    fill: "#304876"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0567 10.543C59.9821 11.6181 58.5645 13.7842 58.5645 16.2818C58.5645 18.5438 59.7275 20.534 61.4881 21.6881L62.0568 14.9753L62.6257 21.6881C64.3863 20.534 65.5493 18.5438 65.5493 16.2818C65.5493 13.7842 64.1314 11.6181 62.0567 10.543Z",
    fill: "#304876"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.817 59.1005C99.4357 59.9836 97.6219 60.0849 96.1039 59.2088C94.7292 58.4151 93.9275 57.0104 93.8438 55.5362L98.1231 57.5455L94.2427 54.8453C95.5618 54.1805 97.1793 54.1724 98.554 54.9658C100.072 55.8421 100.891 57.4631 100.817 59.1005Z",
    fill: "#304876"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5844 73.8787C90.2034 74.7619 88.3894 74.863 86.8714 73.9869C85.4966 73.1935 84.6949 71.7888 84.6113 70.3146L88.8905 72.3239L85.0103 69.6237C86.3293 68.9589 87.9467 68.9506 89.3218 69.7441C90.8395 70.6202 91.659 72.2414 91.5844 73.8787Z",
    fill: "#304876"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4382 0C53.7222 1.70171 55.9663 5.13053 55.9663 9.0837C55.9663 12.6642 54.1253 15.8144 51.3383 17.6411L50.4382 7.01576L49.5383 17.6411C46.7511 15.8144 44.9102 12.6642 44.9102 9.0837C44.9102 5.13058 47.1544 1.70171 50.4382 0Z",
    fill: "#304876"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7332 52.6888C77.5038 50.2479 74.0232 49.1042 70.6091 50.0188C67.5168 50.8472 65.2219 53.1651 64.2891 55.9932L73.6741 54.3119L64.7056 57.5471C66.9278 59.5301 70.0747 60.3905 73.1668 59.5619C76.581 58.6475 79.023 55.9171 79.7332 52.6888Z",
    fill: "#304876"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8266 62.4649C77.1696 63.7319 75.8458 64.598 74.3196 64.598C72.9373 64.598 71.7208 63.8875 71.0156 62.8121L75.118 62.4649L71.0156 62.1174C71.7207 61.042 72.9373 60.3315 74.3196 60.3315C75.8458 60.3315 77.1696 61.1976 77.8266 62.4649Z",
    fill: "#304876"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0044 55.6761C83.4359 57.0366 83.1125 58.5849 82.0332 59.6639C81.0557 60.641 79.6932 60.9986 78.4339 60.7366L81.0889 57.591L77.9424 60.2453C77.6805 58.9864 78.038 57.6242 79.0155 56.6471C80.0947 55.5681 81.6435 55.2448 83.0044 55.6761Z",
    fill: "#304876"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6128 51.5039C55.5658 51.5039 59.5811 55.518 59.5811 60.4696C59.5811 65.4213 55.5658 69.4354 50.6128 69.4354C45.6596 69.4354 41.6445 65.4213 41.6445 60.4696C41.6445 55.518 45.6596 51.5039 50.6128 51.5039Z",
    fill: "#304876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.116e056619306c4c704844e6157aecf4.svg";
export { ForwardRef as ReactComponent };